import axios from 'axios';

const SeriesService = {
	get: async (id = null) => {
		if (id) {
			return await axios.get(`/api/series/${id}`).then((res) => res.data);
		}
		return await axios.get(`/api/series`).then((res) => res.data);
	},
	create: async (data = {}) => {
		return await axios.post(`/api/series`, data).then((res) => res.data);
	},
	update: async (data = {}) => {
		return await axios
			.put(`/api/series/${data.id}`, data)
			.then((res) => res.data);
	},
	delete: async (id) => {
		return await axios.delete(`/api/series/${id}`).then((res) => res.data);
	},
};

export default SeriesService;
